var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-color": "basic",
    className: "help-icon",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 18.7101V16.584C8.84656 16.08 7.92 15.1534 7.41604 14H5.28988C5.96183 16.2578 7.74222 18.0382 10 18.7101ZM5.28988 10H7.41604C7.92 8.84656 8.84656 7.92 10 7.41604V5.28988C7.74222 5.96183 5.96183 7.74222 5.28988 10ZM10 4.25203C10.6392 4.08751 11.3094 4 12 4C12.6904 4 13.3603 4.08744 13.9993 4.25186C13.9995 4.25192 13.9998 4.25198 14 4.25203C16.8112 4.97559 19.0244 7.18879 19.748 10C19.9125 10.6392 20 11.3094 20 12C20 12.6904 19.9126 13.3603 19.7481 13.9993C19.7481 13.9995 19.748 13.9998 19.748 14C19.0244 16.8112 16.8112 19.0244 14 19.748C13.3608 19.9125 12.6906 20 12 20C11.3096 20 10.6397 19.9126 10.0007 19.7481C10.0005 19.7481 10.0002 19.748 10 19.748C7.18878 19.0244 4.97559 16.8112 4.25203 14C4.08751 13.3608 4 12.6906 4 12C4 11.3096 4.08744 10.6397 4.25186 10.0007C4.25192 10.0005 4.25198 10.0002 4.25203 10C4.97559 7.18878 7.18878 4.97559 10 4.25203ZM14 18.7101C16.2578 18.0382 18.0382 16.2578 18.7101 14H16.584C16.08 15.1534 15.1534 16.08 14 16.584V18.7101ZM16.584 10H18.7101C18.0382 7.74222 16.2578 5.96183 14 5.28988V7.41604C15.1534 7.92 16.08 8.84656 16.584 10ZM12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcn);
export default __webpack_public_path__ + "static/media/help-icn.4aaba759caed7cdb1e6623b785b69321.svg";
export { ForwardRef as ReactComponent };